const smScreen = 500;
const mdScreen = 768;

export { smScreen, mdScreen };
